// top-level imports
import React from 'react';
// antd
import Button from 'antd/lib/button';

import Select from 'antd/lib/select';
import message from 'antd/lib/message';
import Input from 'antd/lib/input';
import Form from 'antd/lib/form';
// APOLLO
import GeneralHelpers from 'lib/helpers/GeneralHelpers';

// CONSTANTS & DESTRUCTURING
// ====================================
const FormItem = Form.Item;
const { Option } = Select;

const HELP_MESSAGE_TOPICS = ['Help or Question', 'Feedback', 'Feature Request', 'Bug Report', 'Other'];

// EXPORTED COMPONENT
// ===================================
class HelpForm extends React.Component {
  state = {
    loading: false,
  };

  handleSubmit = e => {
    e.preventDefault();
    const {
      data, mutate, form, createSupportMessage, handleCancel,
    } = this.props;
    this.setState({ loading: true });

    form.validateFields((err, params) => {
      if (err) {
        return this.setState({ loading: false });
      }
      let variables = { params };
      createSupportMessage({ variables })
        .then(() => {
          this.setState({ loading: false });
          handleCancel();
          form.resetFields();
          message.success('we recieved your message!');
        })
        .catch(e => console.log(e));
    });
  };

  render() {
    const { form } = this.props;
    const { getFieldDecorator } = form;
    return (
      <div
        style={{
          height: '100%',
          width: 500,
          maxWidth: '100%',
          margin: 'auto',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Form onSubmit={this.handleSubmit} style={{ width: '100%' }}>
          <FormItem label="Topic">
            {getFieldDecorator('topic', {
              rules: [{ required: true, message: 'Please input a Topic!' }],
            })(
              <Select
                size="large"
                showSearch
                optionFilterProp="children"
                filterOption={GeneralHelpers.selectFilterByLabel}
              >
                {HELP_MESSAGE_TOPICS.map(item => (
                  <Option key={item} value={item}>
                    {item}
                  </Option>
                ))}
              </Select>,
            )}
          </FormItem>
          <FormItem>
            {getFieldDecorator('messageValue', {
              rules: [{ required: false, message: 'Please input a Description!' }],
            })(<Input size="large" placeholder="Tell us what's on your mind..." type="textarea" rows={4} />)}
          </FormItem>
          <FormItem>
            <Button loading={this.state.loading} htmlType="submit" type="primary">
              {!this.state.loading ? 'Submit' : 'Submitting...'}
            </Button>
          </FormItem>
        </Form>
      </div>
    );
  }
}

export default Form.create()(HelpForm);



// WEBPACK FOOTER //
// ./src/components/forms/HelpForm/index.js